import styled from 'styled-components/macro'

const Wrapper = styled.span`
  font-size: 0.8rem;
  margin: 20px 0 20px 0;
  color: #888;
  font-weight: 300;
`

export { Wrapper }
